// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5Gind","label":"styles_label__2iPZF"};